//loader.js
window.$ = window.jQuery = require('jquery')

window.S4 = function S4() {
    return (((1+Math.random())*0x10000)|0).toString(16).substring(1); 
}
 
window.getGuid = function(){
    return (window.S4() + window.S4() + "-" + window.S4() + "-4" + window.S4().substr(0,3) + "-" + window.S4() + "-" + window.S4() + window.S4() + window.S4()).toLowerCase();
}
window.guid = (window.S4() + window.S4() + "-" + window.S4() + "-4" + window.S4().substr(0,3) + "-" + window.S4() + "-" + window.S4() + window.S4() + window.S4()).toLowerCase();

window.clickLog = function(action, component){
    var callerid=window.appConstants.AppName; 
    var url=window.appConstants.clicklogUrl; 
    var contextid = window.appConstants.Allow + "-" + window.guid;
    var requestid = window.getGuid();
    var type = "webpage"
    var hval = "ALLOW=" + window.appConstants.Allow;
      
    var request= {
        "requestid": requestid,
        "contextid": contextid,
        "callerid": callerid,
        "component": component,
        "action": action,
        "type": type
    }
    
    if(window.appConstants.enableClickLogs){
        window.clickLogPost(url, hval, request);
    }
    
  }

window.clickLogPost = function(url, hval, request){
    window.$.ajax({
        type: "POST",
        //url: "https://wbk8ptlj12.execute-api.us-east-1.amazonaws.com/dev/clicklogger",
        url: url,
        crossDomain: true,
        data: JSON.stringify(request),
        contentType: "application/json",
        header: {
            'Authorization': hval
        },
        dataType: "json",
        success: function(data, status){
           //console.log("Data: " + data.statusCode);
        }
   });
}

window.getList = function (){
    window.$.ajax({
      url: "https://ya5odksneh.execute-api.us-east-1.amazonaws.com/dev",
      type: 'GET',
      dataType: 'json', // added data type
      success: function(res) {
         window.makeLayoutTable(res);
      }
  });
}

window.makeLayoutTable = function (data){
      var table = '<div class="programs-data-table">';
      var tblHeader = "<div class=\"programs-data-table__header\"><div>Date</div><div>Program</div><div>Location</div><div>Additional Details</div></div>";
      var tblEachRow = "";
  
      window.$.each(data, function(i, item) {
          tblEachRow += window.returnLayoutRow(item);
      });
      
      var tblEnd = "</div>";
      var htmlContent = table+tblHeader+tblEachRow+tblEnd;
      window.$("#htmlcontent").html(htmlContent);
      //$( "#accordion" ).accordion();
      console.log(htmlContent);
  }

window.returnLayoutRow = function (item){
    var tblRow = "";
    if(!item.completed){
      tblRow = "<div class=\"programs-data-table__row\"><div>" + item.datetime + "</div><div>" + item.title + "</div><div>" + item.provider + "</div><div>" + item.comments + "</div></div>";
    }
    return tblRow;
}
